import Letter from "./Letter";

const Word = ({ word, letters }) => {
  return (
    <div className="word">
      {word.map((c, i) => (
        <Letter char={c} letters={letters} key={i} />
      ))}
    </div>
  );
};

export default Word;
